import { render, staticRenderFns } from "./HotelsList.vue?vue&type=template&id=ca9cca1e&scoped=true"
import script from "./HotelsList.vue?vue&type=script&lang=js"
export * from "./HotelsList.vue?vue&type=script&lang=js"
import style0 from "./HotelsList.vue?vue&type=style&index=0&id=ca9cca1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9cca1e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HotelsSortSelect: require('/home/forge/farescraper.com/components/HotelsSortSelect.vue').default,HotelsMap: require('/home/forge/farescraper.com/components/HotelsMap.vue').default,HotelsMapCard: require('/home/forge/farescraper.com/components/HotelsMapCard.vue').default,HotelsFilters: require('/home/forge/farescraper.com/components/HotelsFilters.vue').default})
